module.exports = __webpack_public_path__ + "img/cloud_1.18a16901.png";